import { FileTextOutlined, PlusOutlined } from '@ant-design/icons'
import { Button, Dropdown } from 'antd'
import { useState } from 'react'
import { useLocation, useNavigate, useParams } from 'react-router-dom'

import { Calendar2Icon, CalendarEditIcon } from 'src/assets'
import { useLocales } from 'src/locales'
import { paths } from 'src/paths'

import { DraftConsultationsModal } from './DraftConsultationsModal'
import { ScheduleConsultationModal } from './ScheduleConsultationModal'

export const NewConsultationButton = () => {
  const { t } = useLocales()
  const { id: personId } = useParams()
  const { pathname } = useLocation()
  const navigate = useNavigate()

  const [isOpen, setIsOpen] = useState(false)
  const [isDraftOpen, setIsDraftOpen] = useState(false)

  const isPatient = pathname.includes('patients')

  const onToggle = () => setIsOpen((prev) => !prev)
  const onToggleDraft = () => setIsDraftOpen((prev) => !prev)

  const dropdownItems = [
    {
      key: 'schedule',
      label: t('consultations.schedule_consultation'),
      icon: <Calendar2Icon />,
      onClick: onToggle
    },
    {
      key: 'manage',
      label: t('consultations.add_new_consultation'),
      onClick: () =>
        personId &&
        navigate(
          isPatient
            ? paths.patients.consultations.new(personId)
            : paths.persons.consultations.new(personId)
        ),
      icon: <CalendarEditIcon />
    },
    {
      key: 'from_draft',
      label: t('consultations.from_draft'),
      icon: <FileTextOutlined />,
      onClick: onToggleDraft
    }
  ]

  return (
    <>
      <Dropdown menu={{ items: dropdownItems }} placement="bottom">
        <Button type="primary" icon={<PlusOutlined />}>
          {t('consultations.new_consultation')}
        </Button>
      </Dropdown>

      {isOpen && <ScheduleConsultationModal onCancel={onToggle} />}
      {isDraftOpen && <DraftConsultationsModal onCancel={onToggleDraft} />}
    </>
  )
}
